import type { GameAction, PublicGameState } from "../shared/game";

export interface RoomResponse {
  code: string;
  token?: string;
  playerId?: string;
  revision: number;
  game: PublicGameState;
}

const request = async <T>(path: string, init?: RequestInit, token?: string): Promise<T> => {
  const response = await fetch(path, {
    ...init,
    headers: {
      ...(init?.body ? { "content-type": "application/json" } : {}),
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...init?.headers
    }
  });
  const result = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(result.error ?? "Request failed.");
  return result;
};

export const createRoom = (input: { name: string; avatar: string; mode: string }) =>
  request<RoomResponse>("/api/rooms", { method: "POST", body: JSON.stringify(input) });

export const joinRoom = (code: string, input: { name: string; avatar: string }) =>
  request<RoomResponse>(`/api/rooms/${code}/join`, { method: "POST", body: JSON.stringify(input) });

export const getRoom = (code: string, token: string) => request<RoomResponse>(`/api/rooms/${code}`, undefined, token);

export const sendAction = (code: string, token: string, revision: number, action: GameAction) =>
  request<RoomResponse>(`/api/rooms/${code}/actions`, { method: "POST", body: JSON.stringify({ revision, action }) }, token);
